export default {
    '1': 'Prodotto sbagliato ordinato',
    '2': 'Ordine duplicato',
    '3': 'Impossibile ricevere',
    '4': 'Altri motivi',
    '-连接已建立-': '-Connessione stabilita-',
    ',才可提币': ', per poter prelevare',
    '[code]值错误': 'Valore di [code] errato',
    '[symbol]参数为空': 'Il parametro [symbol] è vuoto',
    homeDownloadtips41: 'App commerciante',
    '不能为空': 'Non può essere vuoto',
    '不在交易时段': 'Fuori dall\'orario di negoziazione',
    '不在可提现时间内': 'Fuori dall\'orario di prelievo',
    '参数错误': 'Errore di parametro',
    '参数异常，消息获取失败': 'Parametro anomalo, impossibile recuperare il messaggio',
    '操作成功': 'Operazione riuscita',
    '操作类型不能小于0': 'Il tipo di operazione non può essere inferiore a 0',
    '操作类型不是整数': 'Il tipo di operazione non è un numero intero',
    '操作类型为空': 'Il tipo di operazione è vuoto',
    '产品不存在': 'Il prodotto non esiste',
    '产品剩余数量不足': 'Quantità rimanente del prodotto insufficiente',
    '承兑商不存在': 'Il commerciante non esiste',
    '程序错误': 'Errore del programma',
    '持有币种不足': 'Saldo valuta insufficiente',
    '充值价值不得大于最大限额': 'Il valore di ricarica non può superare il limite massimo',
    '充值价值不得小于最小限额': 'Il valore di ricarica non può essere inferiore al limite minimo',
    '充值链错误': 'Errore della catena di ricarica',
    '充值数量不能小于等于0': 'La quantità di ricarica non può essere inferiore o uguale a 0',
    '存在不同杠杆的持仓单': 'Esistono posizioni con leva diversa',
    '存在重复的角色名称': 'Esiste un nome di ruolo duplicato',
    '大于最大采购数量': 'Superiore alla quantità massima di acquisto',
    '代理层级错误': 'Errore di livello agente',
    '待付款的订单无法放行': 'Un ordine in attesa di pagamento non può essere rilasciato',
    '当前地址格式错误': 'Formato dell\'indirizzo attuale errato',
    '当前订单不为待付款状态，无法取消': 'L\'ordine non è in stato di attesa pagamento, impossibile annullare',
    '当前还需交易': 'Sono ancora necessarie ulteriori operazioni',
    '当日才可申购': 'La sottoscrizione è possibile solo nello stesso giorno',
    '当日可提现次数不足': 'Numero di prelievi odierni insufficiente',
    '登陆密码不符合设定': 'La password di accesso non soddisfa i requisiti',
    '登陆密码长度不符合设定': 'La lunghezza della password di accesso non soddisfa i requisiti',
    '登录过期，请重新登录': 'Sessione scaduta, effettua nuovamente l\'accesso',
    '登录密码必须6-12位': 'La password di accesso deve contenere 6-12 caratteri',
    '登录密码不能为空': 'La password di accesso non può essere vuota',
    '登录失败': 'Accesso non riuscito',
    '电话号码已绑定': 'Il numero di telefono è già collegato',
    '电话号码已绑定其他用户': 'Il numero di telefono è già collegato a un altro utente',
    '订单不存在': 'L\'ordine non esiste',
    '订单已取消': 'Ordine annullato',
    '订单已取消，无法放行': 'Ordine annullato, impossibile rilasciare',
    '订单已完成，无法放行': 'Ordine completato, impossibile rilasciare',
    '发现新版本，请升级到最新版本': 'Nuova versione disponibile, aggiorna all\'ultima versione',
    '服务器错误': 'Errore del server',
    '服务器错误(500)': 'Errore del server (500)',
    '该产品未上架': 'Questo prodotto non è in vendita',
    '该产品已上市，无法购买': 'Questo prodotto è già in vendita, impossibile acquistare',
    '该订单已取消': 'Questo ordine è stato annullato',
    '该广告剩余数量不足': 'Quantità rimanente di questo annuncio insufficiente',
    '该基金尚未开放购买': 'Questo fondo non è ancora aperto all\'acquisto',
    '该基金尚已封闭': 'Questo fondo è già chiuso',
    '该邮箱已被订阅': 'Questa email è già iscritta',
    '格式有误:充值金额不能小于1(包含俩位小数)': 'Errore di formato: l\'importo di ricarica non può essere inferiore a 1 (due decimali)',
    '跟单倍数输入错误': 'Inserimento errato del moltiplicatore di copy trading',
    '跟单参数输入错误': 'Inserimento errato dei parametri di copy trading',
    '更新提醒': 'Promemoria aggiornamento',
    '工作地址不能为空': 'L\'indirizzo di lavoro non può essere vuoto',
    '购买矿机时间不得低于托管订单剩余时间': 'La durata di acquisto della macchina di mining non può essere inferiore al tempo residuo dell\'ordine di hosting',
    '广告不存在': 'L\'annuncio non esiste',
    '广告已下架': 'L\'annuncio è stato rimosso',
    '基金剩余购买金额不足': 'Importo di acquisto rimanente del fondo insufficiente',
    '家庭地址不能为空': 'L\'indirizzo di casa non può essere vuoto',
    '交易员不存在': 'Il trader non esiste',
    '交易员不能跟随自己': 'Il trader non può seguire se stesso',
    '交易员跟随人数已满': 'Il numero di follower del trader è al completo',
    '交易员未开启带单': 'Il trader non ha attivato il copy trading',
    '交易员无法跟随另一个交易员': 'Un trader non può seguire un altro trader',
    '角色被用户关联，不可删除': 'Il ruolo è collegato agli utenti, impossibile eliminare',
    '角色不存在': 'Il ruolo non esiste',
    '金额不在购买区间': 'L\'importo non rientra nell\'intervallo di acquisto',
    '金额错误': 'Errore di importo',
    '旧密码不能为空': 'La vecchia password non può essere vuota',
    '旧密码不正确': 'La vecchia password non è corretta',
    '可平仓合约张数不足': 'Numero di contratti chiudibili insufficiente',
    '矿机不存在': 'La macchina di mining non esiste',
    '矿机未解锁，无法购买': 'La macchina di mining non è sbloccata, impossibile acquistare',
    '历史基金无法购买': 'I fondi storici non possono essere acquistati',
    '连续输入错误三次，请3分钟后再试': 'Tre inserimenti errati consecutivi, riprova tra 3 minuti',
    '领取成功': 'Riscattato con successo',
    '买入金额需要在区间内': 'L\'importo di acquisto deve rientrare nell\'intervallo',
    '卖方无法取消该订单': 'Il venditore non può annullare questo ordine',
    '没有找到用户': 'Nessun utente trovato',
    verificationCode: 'Codice di verifica',
    pleaseEnterVerificationCode: 'Inserisci il codice di verifica',
    pleaseEnterUsername: 'Inserisci il nome utente',
    username: 'Nome utente',
    getVerificationCode: 'Ottieni codice',
    tryAgainLater: 'secondi per riprovare',
    '密码必须6-12位': 'La password deve contenere 6-12 caratteri',
    '密码不能为空': 'La password non può essere vuota',
    '密码不正确': 'La password non è corretta',
    '您当前可分配额度不足': 'Il tuo limite assegnabile attuale è insufficiente',
    '您没有符合条件的收款方式': 'Non hai un metodo di pagamento idoneo',
    '您已存在订单': 'Hai già un ordine',
    '您已购买过体验矿机,不得重复购买': 'Hai già acquistato una macchina di mining di prova, impossibile riacquistare',
    '亲属地址不能为空': 'L\'indirizzo del familiare non può essere vuoto',
    '亲属电话不能为空': 'Il telefono del familiare non può essere vuoto',
    '亲属关系不能为空': 'Il grado di parentela non può essere vuoto',
    '亲属姓名不能为空': 'Il nome del familiare non può essere vuoto',
    '请检查网络连接': 'Controlla la connessione di rete',
    '请上传图片': 'Carica un\'immagine',
    '请稍后再试': 'Riprova più tardi',
    '请稍后重试': 'Riprova più tardi',
    '请输入充值币种': 'Inserisci la valuta di ricarica',
    '请输入内容': 'Inserisci il contenuto',
    '请输入搜索关键字': 'Inserisci la parola chiave di ricerca',
    '请输入正确的货币数量': 'Inserisci una quantità di valuta corretta',
    '请输入正确的金额': 'Inserisci un importo corretto',
    '请输入正确的数量': 'Inserisci una quantità corretta',
    '请输入正确的质押金额': 'Inserisci un importo di staking corretto',
    '请输入正确的质押天数': 'Inserisci un numero di giorni di staking corretto',
    '请填写正确的电话号码': 'Inserisci un numero di telefono corretto',
    '请填写正确的验证码': 'Inserisci un codice di verifica corretto',
    '请填写正确的邮箱地址': 'Inserisci un indirizzo email corretto',
    '请先绑定谷歌验证器': 'Collega prima Google Authenticator',
    '请先添加收款方式': 'Aggiungi prima un metodo di pagamento',
    '请先通过高级认证': 'Completa prima la verifica avanzata',
    '请选择买卖方式': 'Seleziona il metodo di acquisto/vendita',
    '请选择正确的币种': 'Seleziona la valuta corretta',
    '请重新登录': 'Effettua nuovamente l\'accesso',
    '渠道未开通': 'Canale non attivato',
    '取消': 'Annulla',
    '确认': 'Conferma',
    '申购数量错误': 'Quantità di sottoscrizione errata',
    '申请成功': 'Richiesta riuscita',
    '身份证已实名过!': 'Il documento è già verificato!',
    '审核已通过': 'Revisione approvata',
    '审核中': 'In revisione',
    '实名认证未通过，无法进行高级认证': 'Verifica dell\'identità non superata, impossibile effettuare la verifica avanzata',
    '收款方输入错误': 'Inserimento errato del beneficiario',
    '授权状态未成功': 'Stato di autorizzazione non riuscito',
    '赎回状态异常': 'Stato di rimborso anomalo',
    '所选汇率不存在': 'Il tasso di cambio selezionato non esiste',
    '提币数量不能小于等于0': 'La quantità di prelievo non può essere inferiore o uguale a 0',
    '提交失败': 'Invio non riuscito',
    '提交失败，当前有未处理订单': 'Invio non riuscito, ci sono ordini non elaborati',
    '提示': 'Avviso',
    '提现不得大于限额': 'Il prelievo non può superare il limite',
    '提现不得小于限额': 'Il prelievo non può essere inferiore al limite',
    '图片不得大于10M': 'L\'immagine non può superare 10 MB',
    '图片不得大于2M': 'L\'immagine non può superare 2 MB',
    '图片大小不能超过2M！': 'La dimensione dell\'immagine non può superare 2 MB!',
    '图片上传失败': 'Caricamento dell\'immagine non riuscito',
    '推荐码不正确': 'Il codice di riferimento non è corretto',
    '推荐人无权限推荐': 'Il referente non ha l\'autorizzazione a riferire',
    '委托数量(张)必填': 'La quantità dell\'ordine (contratti) è obbligatoria',
    '委托数量(张)不能小于等于0': 'La quantità dell\'ordine (contratti) non può essere inferiore o uguale a 0',
    '未绑定谷歌验证器': 'Google Authenticator non collegato',
    '未绑定手机号': 'Nessun numero di telefono collegato',
    '未绑定邮箱': 'Nessuna email collegata',
    '未发现授权记录': 'Nessun record di autorizzazione trovato',
    '未实名认证，是否认证？': 'Non verificato. Verificare ora?',
    '未授权访问': 'Accesso non autorizzato',
    '未找到符合条件的匹配订单': 'Nessun ordine corrispondente trovato',
    '未找到匹配的收益记录': 'Nessun record di guadagni corrispondente trovato',
    myComment: 'Le mie recensioni',
    myPoint: 'I miei punti',
    accountInfo: 'Informazioni account',
    myBalance: 'Il mio saldo',
    myCoupon: 'I miei coupon',
    unused: 'Non utilizzato',
    used: 'Utilizzato',
    expired: 'Scaduto',
    expires: 'Valido fino al',
    minSpend: 'A partire da',
    availableBalance: 'Saldo disponibile',
    personalDeposit: 'Saldo',
    useDepositBalance: 'Usa il saldo per lo sconto',
    depositDeduct: 'Detrazione dal saldo',
    useMaxDeposit: 'Detrazione totale',
    balanceHistory: 'Cronologia saldo',
    recordCount: 'Totale {count} record',
    depositType: 'Tipo di transazione',
    balanceAfter: 'Saldo residuo',
    depositTypeRecharge: 'Ricarica saldo',
    depositTypeAdjustment: 'Rettifica saldo',
    depositTypeOrderPayment: 'Pagamento ordine',
    depositTypeOrderRefunds: 'Rimborso ordine',
    depositTypeDistributionCommission: 'Commissione di distribuzione',
    depositTypeDistributionWithdrawal: 'Prelievo di distribuzione',
    depositTypeOther: 'Altro',
    income: 'Entrate',
    expense: 'Uscite',
    description: 'Descrizione',
    myFootprint: 'La mia cronologia',
    '无权限': 'Nessuna autorizzazione',
    '无效的UID': 'UID non valido',
    '系统参数错误': 'Errore parametro di sistema',
    '系统存在相同[系统登录名]！': 'Il sistema contiene già lo stesso [nome di accesso]!',
    '系统错误，请稍后重试': 'Errore di sistema, riprova più tardi',
    '下单不能小于最小金额限制': 'L\'ordine non può essere inferiore all\'importo minimo',
    '校验IP不合法': 'IP di verifica non valido',
    '新密码不能为空': 'La nuova password non può essere vuota',
    '新密码不一致': 'Le nuove password non corrispondono',
    '新密码确认不能为空': 'La conferma della nuova password non può essere vuota',
    '行情获取异常，稍后再试': 'Impossibile recuperare i dati di mercato, riprova più tardi',
    '验证类型不能为空': 'Il tipo di verifica non può essere vuoto',
    '验证码不能为空': 'Il codice di verifica non può essere vuoto',
    '验证码不正确': 'Il codice di verifica non è corretto',
    '验证码错误': 'Codice di verifica errato',
    '页码不能小于等于0': 'Il numero di pagina non può essere inferiore o uguale a 0',
    '页码不是整数': 'Il numero di pagina non è un intero',
    '已领取': 'Già riscattato',
    '用户不存在': 'L\'utente non esiste',
    '用户名必须由数字和英文字母组成': 'Il nome utente deve essere composto da numeri e lettere latine',
    '用户名不存在': 'Il nome utente non esiste',
    '用户名不符合设定': 'Il nome utente non soddisfa i requisiti',
    '用户名不能为空': 'Il nome utente non può essere vuoto',
    '用户名参数为空': 'Il parametro nome utente è vuoto',
    '用户名重复': 'Nome utente duplicato',
    '用户剩余数量不足': 'Quantità rimanente di utenti insufficiente',
    '用户已跟随交易员': 'L\'utente segue già il trader',
    '邮箱已绑定': 'Email già collegata',
    '邮箱已绑定其他用户': 'Email già collegata a un altro utente',
    '余额不足': 'Saldo insufficiente',
    shop_order_insufficientBalance: 'Saldo del conto insufficiente',
    '帐户异常需要进行C3认证，请联系在线客服。': 'Account anomalo, richiesta verifica C3. Contatta l\'assistenza clienti online.',
    '找不到用户': 'Utente non trovato',
    flashSale: 'Vendita flash',
    groupBuy: 'Acquisto di gruppo',
    groupBuying: 'Acquisto di gruppo',
    couponCenter: 'Centro coupon',
    pointMall: 'Negozio punti',
    liveList: 'Diretta',
    endsIn: 'Termina tra',
    soldOut: 'Venduto',
    people: 'persone',
    joined: 'Hanno partecipato',
    startGroup: 'Avvia gruppo',
    getCoupon: 'Ottieni',
    '直线关系，不能修改推荐': 'Relazione diretta, riferimento non modificabile',
    '重复提交': 'Invio duplicato',
    '转账币种不能为空': 'La valuta di trasferimento non può essere vuota',
    '转账数量不能小于等于0': 'La quantità di trasferimento non può essere inferiore o uguale a 0',
    '状态不能小于0': 'Lo stato non può essere inferiore a 0',
    '状态不是整数': 'Lo stato non è un intero',
    '资金密码必须6-12位': 'La password dei fondi deve contenere 6-12 caratteri',
    '资金密码不符合设定': 'La password dei fondi non soddisfa i requisiti',
    '资金密码不能为空': 'La password dei fondi non può essere vuota',
    '资金密码错误': 'Password dei fondi errata',
    '资金密码长度不符合设定': 'La lunghezza della password dei fondi non soddisfa i requisiti',
    'UID不能为空': 'L\'UID non può essere vuoto',
    required: 'Questo campo è obbligatorio',
    nickname: 'Nickname',
    enterNickname: 'Inserisci il nickname',
    gender: 'Sesso',
    male: 'Uomo',
    female: 'Donna',
    secret: 'Riservato',
    birthday: 'Compleanno',
    selectDate: 'Seleziona data',
  cancelOrderMap: {
    0: "Non lo voglio.",
    1: "Prodotto smarrito",
    2: "Ordine duplicato",
    3: "Ricezione fallita",
    4: "Altri motivi",
  },
  "加值": "Valore aggiunto",
  "提领": "Sollevare",
  "银行卡": "Carta bancaria",
  "联系商家": "Contatta il commerciante",
  "电商批发商场": "Mercato all'ingrosso di e-commerce",
  "用户未发表评论": "L'utente non ha commentato",
  "请输入完整的支付密码!" : "Inserisci la password di pagamento completa!",
  "订单": "Ordine",
  "备注": "Nota",
  "获取验证码": "Ottieni il codice di verifica",
  "请输入验证码": "Inserisci il codice di verifica",
  "验证码": "Codice di verifica",
  "发送": "Invia",
  "已发送，请注意查收": "Inviato, si prega di tenere conto",
  "当前余额": "Saldo attuale",
  "平台人工发起退款": "Il rimborso è stato avviato manualmente dalla piattaforma",
  "下单成功，等待付款": "Ordine effettuato con successo, in attesa di pagamento",
  "下单成功，付款成功": "Ordine effettuato con successo, pagamento andato a buon fine",
  "已发货，正在运输中": "Spedito, in trasporto",
  "订单已取消，原因:手动发起取消订单": "L'ordine è stato annullato. Motivo: annulla l'ordine manualmente.",
  "订单已取消，原因:超时自动取消订单": "L'ordine è stato annullato. Motivo: l'ordine verrà annullato automaticamente al timeout.",
  "商家已确认，已进入备货状态": "Il commerciante è stato confermato ed è entrato nello stato stock.",
  "系统发货成功": "Consegna del sistema riuscita",
  "订单已签收": "Ordine Ricevuto",
  "发起退款申请": "Avviare una richiesta di rimborso",
  "退款成功": "Rimborso riuscito",
  "退款失败": "Rimborso non riuscito",
  "订单退款成功": "Rimborso dell'ordine riuscito",
  "订单退款失败": "Rimborso dell'ordine non riuscito",
  "系统默认好评": "Il sistema imposta automaticamente le recensioni favorevoli",
  "请输入关键字搜索": "Inserisci la parola chiave per la ricerca",
  "猜你喜欢": "Immagino che ti piaccia",
  "订单已完成": "L'ordine è completato",
  "热销推荐": "Raccomandazione di vendita calda",
  "头像选择": "Selezione dell'avatar",
  "修改头像": "Modifica il tuo avatar",
  subOrder: "Inviare ordine",

  "mailboxCheck": "Si prega di inserire l'indirizzo e-mail corretto",
  "switchLang": "Passa a un'altra lingua per visualizzare",
  "myCart": "Il mio carrello",
  "notQua": "Le condizioni di qualificazione non sono soddisfatte.",
  "noSmaller": "L'importo applicato non può essere inferiore a",
  "nomax": "L'importo massimo della domanda non può superare",
  "evaluationUploading": "Hai ancora il caricamento delle immagini. Per favore riprova più tardi",
  "evaluateInput": "Recensione con immagini",
  "moneyOrderStatus": "Lo stato dell'ordine",
  "coinBlock": "Accordo valutario",
  "dealing": "In corso",
  "dealSuccess": "Riuscito",
  "dealFail": "Fallire",
  "payCertificate": "Certificato di pagamento",
  "handleFee": "Costo del servizio",
  "highOpinion": "Buone recensioni",
  "mediumOpinion": "Recensione media",
  "lowOpinion": "Recensioni negative",
  "hasImage": "Con immagini",
  "rechargeMethod": "Modalità di ricarica",
  "scanAndDown": "Scansiona il codice QR Scarica l'APP",
  "receivedAddress": "Indirizzo di ricezione",
  "ActualLedger": "Scontrino vero e proprio",
  "view": "Visualizzazione",
  "withdrawNum": "Quantità di prelievo di contanti",
  "rechargeNum": "Quantità di ricarica",
  "date": "Data",
  "walletHistory": "Storia del portafoglio",
  "accountBalance": "Saldo del conto",
  "accountReview": "Panoramica dell'Account",
  "rated": "Rivisto",
  "receiver": "Ricevitore",
  "orderStatus": "Stato",
  "orderTime": "Tempo",
  "tax": "Tassazione",
  "discount": "Sconto",
  "productInfo": "Informazioni sul prodotto",
  "paramError": "Errore di parametro",
  "orderInfo": "Informazioni sull'ordine",
  "rebuy": "Un altro ordine",
  "pleaseCorrectAddress": "Inserisci l'indirizzo corretto per il prelievo di contanti",
  "pleaseInputCorrectNumber": "Inserisci un numero maggiore di 0",
  "vcodePass": "Verifica superata!",
  "vcodeFail": "Autenticazione fallita. Per favore riprovare",
  "uploading": "Caricamento...",
  "uploadSuccess": "Caricamento riuscito",
  "uploadError": "Caricamento fallito. Per favore riprova",
  "registerSuccess": "Registrazione riuscita",
  "pleaseSetMobileNumber": "Si prega di impostare il numero di telefono",
  "unSelectedProduct": "Non hai selezionato un prodotto",
  "loginSuccess": "Accesso riuscito",
  "pleaseSetAreaCode": "Inserisci il nome del paese e il prefisso per la ricerca",
  "login": "Login",
  "register": "Registrazione",
  "logout": "Uscita",
  "noData": "Nessun dato trovato",
  "search": "Ricerca",
  "historySearch": "Ricerca storica",
  "empty": "Vuoto",
  "home": "Pagina iniziale",
  "favorableRate": "Tasso di buone recensioni",
  "classification": "Categoria",
  "searchTips": "Ricerca fonte/prodotto/fornitore/ordine",
  "dailyNewArrival": "Quotidiano nuovi prodotti elencati",
  "more": "Di più",
  "recommend": "Raccomandazione",
  "recommendedProducts": "Prodotti consigliati",
  "recommendedStore": "Negozi consigliati",
  "buyNow": "Acquista adesso",
  "addCart": "Aggiungere al carrello della spesa",
  "complex": "Integrato",
  "price": "Prezzo",
  "retailPrice": "Prezzo al dettaglio",
  "originPrice": "Prezzo originale",
  "service": "Assistenza clienti",
  "collect": "Preferiti",
  "sold": "Volume delle vendite",
  "pageviews": "Quantità di navigazione",
  "quantity": "Quantità",
  "freight": "Carico",
  "shipping": "Spedizione",
  "ship": "Barca",
  "buyTips": "Spedizione entro 24 ore dall'ordine. I seguenti ordini sono sotto controllo logistico e potrebbero essere spediti in ritardo. Si prega di prestare attenzione alle informazioni logistiche o contattare il servizio clienti.",
  "totalPrice": "Prezzo totale",
  "addCartMessage": "Aggiunto con successo al carrello",
  "addCartMessageFaild": "Il prodotto esiste già nel carrello.",
  "myAccount": "Il mio conto",
  "buyHistory": "Record di acquisto",
  "wishlist": "Prodotti preferiti",
  "trackOrder": "Ordine",
  "account": "Account:",
  "sellerZone": "Zona mercantile",
  "beSeller": "Diventa un commerciante",
  "sellerPanelLogin": "Accesso commerciante",
  "footTip": "© Copyright {name} Ltd 2024",
  "footTips": "{name} Limited è autorizzata e regolamentata dalla Financial Conduct Authority come mediatore creditizio (713206) e tratta esclusivamente con l'istituto di credito Home Retail Group CardServices Limited come {name} Financial Services. {name} Financial Services è autorizzata e regolamentata dalla Financial Conduct Authority a fornire credito (716148). Home Retail GroupCard Services Limited è registrata nel Regno Unito (04007072) ad Avebury, 489-499 Avebury Boulevard, Milton Keynes, Regno Unito. MK9 2NW.",
  "item": "Articolo",
  "checkout": "Effettua un ordine",
  "productDescription": "Descrizione del prodotto",
  "userEvaluation": "Recensioni degli utenti",
  "AllProducts": "Tutti i prodotti",
  "followers": "Seguire",
  "sales": "Volume delle vendite",
  "visitStore": "Visita il negozio",
  "authentic": "100% genuino",
  "dayReturns7": "7 giorni di ritorno",
  "shippingDiscounts": "Sconto sul trasporto",
  "safePayment": "Pagamento sicuro",
  "followed": "Seguito",
  "dashboard": "Pannello degli strumenti",
  "myOrder": "Il mio ordine",
  "setUp": "Impostare",
  "successTips": "Riuscito",
  "copySuccess": "Replica riuscita",
  "balance": "Saldo(USDT)",
  "sort": "Tipo",
  "commodity": "Prodotto",
  "browse": "Volume delle vendite",
  "recharge": "Ricaricare",
  "commodityCollection": "Collezione di prodotti",
  "withdraw": "Ritiro contanti",
  "defaultAddress": "Indirizzo predefinito",
  "addNewAddress": "Aggiungi un nuovo indirizzo",
  "withdrawRecord": "Record di prelievo di contanti",
  "serialNumber": "Numero d'ordine.",
  "time": "Tempo",
  "amount": "Quantità",
  "processing": "In corso",
  "fail": "Fallire",
  "blockchainNetwork": "Rete blockchain",
  "records": "Documentazione",
  "withdrawAddress": "Indirizzo per il prelievo di contanti",
  "withdrawInputTips": "Si prega di inserire l'indirizzo di ritiro",
  "copy": "Replica",
  "enterTips": "Prego entra",
  "actualAccount": "Conto reale",
  "handlingFee": "Costo del servizio",
  "confirm": "Conferma ricezione",
  "previous": "Passo precedente",
  "pleaseEnterAddress": "Inserisci l'indirizzo",
  "pleaseEnterQuantity": "Si prega di inserire la quantità",
  "withdrawSuccess": "Ordini inviati con successo",
  "saveQr": "Salva codice QR",
  "pleaseEnterAmount": "Inserisci l'importo della ricarica",
  "expectedArrival": "Arrivo previsto",
  "currentRate": "Tasso di cambio attuale",
  "uploadTips": "Prova di pagamento (carica la schermata dei dettagli di pagamento)",
  "clickUpload": "Clicca per caricare",
  "uploadPhoto": "Si prega di caricare foto",
  "rechargeSuccessful": "Ricarica riuscita",
  "rechargeTips": "\"Richiesta di ricarica: \"\"Si prega di compilare l'importo effettivo del trasferimento in modo veritiero. In caso contrario, il sistema potrebbe non superare l'approvazione e influire sull'avanzamento della ricarica.\"",
  "rechargeRecord": "Ricarica record",
  "all": "Tutto",
  "pending": "Essere pagato",
  "cancelled": "Annullato",
  "delivered": "Essere spedito",
  "confirmed": "Confermato",
  "receipt": "Da ricevere",
  "harvested": "Ricevuto",
  "comment": "Da rivedere",
  "refund": "Rimborso/post-vendita",
  "cancelOrder": "Annulla Ordine",
  "cancelReason": "Motivo della cancellazione",
  "cancelOrderTitle": "Seleziona un motivo per l'annullamento dell'ordine",
  "returnOrderTitle": "Si prega di selezionare il motivo del reso",
  "refundInstructions": "Istruzioni per il rimborso",
  "returnDetailTips": "Si prega di dare una recensione sul prodotto",
  "cancel": "Annulla Ordine",
  "cancelOrder1": "Prodotto non ricevuto",
  "cancelOrder2": "Non mi piace, non lo voglio",
  "cancelOrder3": "Il venditore ha spedito la merce sbagliata",
  "cancelOrder4": "Marchio falso",
  "cancelOrder5": "Meno spedizione, spedizione mancata",
  "cancelOrder6": "Prodotto ricevuto danneggiato",
  "cancelOrder7": "C'è un problema di qualità",
  "cancelOrder8": "Negoziare il rimborso con il commerciante",
  "cancelOrder9": "Altri motivi",
  "cancelOrderSuccess": "Ordine annullato con successo",
  "returnOrderSuccess": "Invia con successo",
  "orderName": "Nome",
  "orderEmail": "E-mail",
  "orderAddress": "Indirizzo",
  "orderNation": "Paese",
  "orderState": "Stato",
  "orderCity": "Città",
  "orderPostCode": "Codice Postale",
  "orderAmount": "Quantità",
  "orderPrefix": "Ordine totale",
  "orderFee": "Le tasse",
  "orderSpecification": "Specifica",
  "orderCommodity": "Prodotto",
  "orderQuantity": "Quantità",
  "orderUnitprice": "Prezzo unitario",
  "orderFreight": "Carico",
  "orderTax": "Imposta",
  "orderTotal": "Totale",
  "PaymentOrder": "Ordine di pagamento",
  "Evaluate": "Revisione",
  "CancelOrder": "Annulla Ordine",
  "RemindShip": "Ricorda per la spedizione",
  "Refund": "Rimborso",
  "Submitareview": "Invia recensioni",
  "Information": "Informazione",
  "wrongPassword": "Errore password più di 3 volte. Si prega di riprovare domani.",
  "Operate": "Operazione",
  "Item": "Elementi)",
  "From": "Da",
  "hint": "Suggerimenti",
  "CheckDetails": "Visualizza dettagli",
  "Payment": "Pagamento",
  "Cancel": "Annulla",
  "refundSuccessfully": "Rimborso riuscito",
  "pendingPayment": "Essere pagato",
  "pay": "Pagamento",
  "LoginPassword": "Password per il login",
  "sure": "Ovviamente",
  "shippingAddress": "Indirizzo di ricezione",
  "transactionPassword": "Parola d'ordine della transazione",
  "markDefaultAddress": "Contrassegna come predefinito Indirizzo di spedizione",
  "edit": "A cura di",
  "delete": "Eliminare",
  "Opt": "Selezionare",
  "piece": "Pz",
  "orderDetails": "Dettagli dell'ordine",
  "shopCollection": "Aggiungi il negozio ai preferiti",
  "addAddress": "Aggiungi un nuovo indirizzo",
  "signUp": "Registrazione",
  "loginTips": "Hai già un account?",
  "loginIn": "Login",
  "mobile": "Telefono n",
  '购物车还没有商品': "Il carrello non ha ancora prodotti",
  '去购物': "Vai a fare shopping",
  "modifyAddress": "Modifica indirizzo",
  "desc": "Imposta come indirizzo predefinito",
  "keep": "Mantenere",
  "onlineService": "Servizi online",
  "send": "Inviare",
  "EsShop": "Negozio online",
  "desc3": "Inserisci la password della transazione",
  "desc4": "Inserisci la password della tua transazione",
  "desc6": "Inserisci nuovamente la password della transazione",
  "setUpPayPaw": "Imposta la password della transazione",
  "setSuccess": "Installazione riuscita",
  "confirmPayPaw": "Conferma la password della transazione",
  "paymentSuccessful": "Pagamento riuscito",
  "desc5": "Indirizzo di spedizione errato? Contatto",
  "customeService": "Servizio clienti in linea",
  "BackHome": "Torna alla pagina iniziale",
  "Checkorder": "Visualizza l'ordine",
  "ForgotPassword": "Hai dimenticato la password?",
  "signIn": "Login",
  "noAccount": "Nessun numero di conto?",
  "pleaseEnterAccount": "Inserisci il numero di conto",
  "pleaseEnterPassword": "Per favore, inserisci la password",
  "password": "Parola d'ordine",
  "mobilePhone": "Numero di telefono",
  "pleaseEnterPhoneNumer": "Si prega di impostare il numero di telefono",
  "setPassword": "Impostare la password",
  "noDataFound": "Nessun dato trovato",
  "searchCountry": "Inserisci il nome del paese e il prefisso per la ricerca",
  "pleaseEnterEmail": "Si prega di impostare la casella di posta",
  "invitationCode": "Codice invito",
  "plaeseEnterInvitaionCode": "Si prega di impostare il codice di invito",
  "pleaseSetLoginPassword": "Si prega di impostare la password di accesso",
  "selectDeliveryAddress": "Seleziona l'indirizzo di spedizione",
  "totalOf": "Totale",
  "items": "Articolo",
  "orderSummary": "Riepilogo dell'ordine",
  "paymentMethod": "Metodo di pagamento",
  "Balance": "Bilancia",
  "payPal": "PayPal",
  "notOpen": "Questo metodo di pagamento non è ancora disponibile per la tua regione",
  "mastercard": "MasterCard",
  "additional": "Extra",
  "handlingfee": "Tassa di servizio richiesta",
  "goodsNumber": "Quantità di prodotti",
  "deliveryFee": "Trasporto",
  "totalNum": "Totale",
  "new": "Nuovo",
  "oldPassword": "Vecchia password",
  "pleaseEnterOldPassword": "Inserisci la vecchia password",
  "newPassword": "Nuova password",
  "plaseeEnterNewPassword": "Inserisci la nuova password",
  "confirmPassword": "Conferma password",
  "plaseeENterConfirmPassword": "Inserisci la password di conferma",
  "twoPawword": "Due password non sono uguali",
  "rechargeAddress": "Indirizzo di ricarica",
  "plaseEnterRechargeAddress": "Inserisci l'indirizzo di ricarica",
  "userCenter": "Centro personale",
  "merchantSettled": "Ingresso mercantile",
  "upNew": "Nuovo prodotto elencato",
  "balanceNot": "Il saldo non è sufficiente. Si prega di ricaricare.",
  "NoProductSelected": "Prodotto non ancora selezionato",
  "ShippingAddressNotSet": "Indirizzo di spedizione non impostato",
  "consigneeName": "Nome del destinatario",
  "email": "E-mail:",
  "areaCode": "Prefisso internazionale",
  "phoneNumber": "Numero di telefono",
  "nation": "Paese",
  "state": "Provincia/Stato/Stato",
  "city": "Città",
  "postCode": "Codice Postale",
  "address": "Indirizzo dettagliato",
  "addAddressOrModifyAddress": "Aggiungi nuovo indirizzo/Modifica indirizzo",
  "setAsTheDefaultAddress": "Imposta come indirizzo predefinito",
  "proceed": "Continua",
  "btnSure": "Confermare",
  "pleaseInput": "Prego entra",
  "allProduct": "Tutti i prodotti",
  "myCommodityCollection": "Prodotti preferiti",
  "myFollowedShops": "Segui il negozio",
  "mySold": "Venduto",
  "myPageviews": "Quantità di navigazione",
  "myPraiseRate": "Tasso di buone recensioni",
  "myUnfollow": "Smetti di seguire",
  "inputNum": "Numeri",
  "inpuEmailErro": "Inserisci l'indirizzo email corretto",
  "goodsShip": "Spedizione",
  "goodsShipTips": "I prodotti verranno spediti entro 24 ore dall'ordine. Se esiste un controllo logistico per il seguente ordine, l'ordine potrebbe essere ritardato. Si prega di prestare attenzione alle informazioni logistiche dell'ordine o contattare il servizio clienti.",
  "goodsFreight": "Trasporto",
  "goodsFreeShipping": "Gratuito",
  "goodsFreightTips1": "1. Composizione del trasporto transfrontaliero del prodotto: trasporto = tassa di spedizione + trasporto a lunga distanza + tassa di consegna",
  "goodsFreightTips2": "2. Se le condizioni di affrancatura non sono soddisfatte, il trasporto sarà addebitato in base alle condizioni effettive.",
  "goodsFreightTips3": "3. Il diritto di interpretazione finale appartiene alla piattaforma.",
  "pleaseValidPostCode": "Inserisci più di 4 cifre",
  "pleaseValidEmail": "Inserisci l'indirizzo email corretto",
  "pleaseValidPhone": "Inserisci il numero di telefono corretto",
  "productAvailable": "Questo prodotto è stato rimosso",
  "validatorMaxNumber": "L'importo supera il limite",
  "validatorRequire": "Gli elementi obbligatori non possono essere nulli",
  "validatorPhone": "Inserisci il numero di telefono corretto",
  "validatorEmail": "Inserisci il formato email corretto",
  "validatorPassword": "La password è composta da 6-12 cifre o lettere(contiene caratteri speciali)",
  "validatorSixNumber": "Inserisci 6 cifre pure",
  "validatorFourMoreNumber": "Inserisci una combinazione di 4-32 cifre o lettere",
  "validatorIpRule": "Formato IP errato",
  "validatorChineseAndEnglish": "Solo cinese e inglese, inserire l'intervallo: 8-64 caratteri",
  "collectionSuccess": "Aggiungi ai preferiti con successo",
  "followedSuccess": "Segui riuscito",
  "cancelSuccess": "Annullato con successo",
  "evaluateOrder": "Recensione con immagini",
  "evaluateOrderPlaceholder": "Si prega di rivedere i prodotti",
  "operationSuccess": "Operazione riuscita",
  "confirmReceiveGoods": "Confermare o meno la ricezione del prodotto",
  "evaluateOrderSuccess": "Revisione riuscita",
  "yesterday": "Ieri",
  "notLogin": "Non hai ancora effettuato l'accesso.",
  "delAllHistoryRecord": "Sei sicuro di voler eliminare tutti i record della cronologia?",
  "or": "O",
  "tipsRemindsText": "Il commerciante riceverà un promemoria dopo che la spedizione è stata ricordata",
  "tipsRemindsCount": "Può essere ricordato solo una volta.",
  "tipsRemindsMerchant": "Ricorda ai commercianti",
  "tipsRemindsSuccess": "Promemoria riuscito",
  "noCartTips": "Il tuo carrello è vuoto. Inizia a fare acquisti.",
  "defaultRate": "Il sistema imposta automaticamente le recensioni favorevoli",
  "prevPage": "Pagina precedente",
  "nextPage": "Pagina successiva",
  "returnApply": "Richiesta di rimborso",
  "returnReason": "Motivo del rimborso",
  "returnAmount": "Importo del reso",
  "returnRemark": "Istruzioni per la restituzione",
  order: {
    cancel: "Annulla Ordine",
    confirm: "Conferma ricezione",
    payment: "Paga ora",
    remind: "Ricorda per la spedizione",
    return: "Richiesta di rimborso del prodotto",
    evaluate: "Rivedi ora",
    logistics: "Visualizza la logistica",
    noRefund: "Non rimborsato",
    refunding: "Rimborso in corso",
    refundSuccess: "Rimborso riuscito",
    refundFail: "Rimborso non riuscito",
        expressCompany: 'Corriere',
        trackingNo: 'Numero di tracciamento',
        noOrderShipping: 'Nessuna informazione di spedizione',
        noTransitSteps: 'Nessun aggiornamento di tracciamento',
        logisticsLoadFail: 'Impossibile caricare la logistica. Riprova più tardi.'
  },
  "remindTitle": "Ricorda per la spedizione",
  "remindContent": "Dopo il sollecito della spedizione, il commerciante riceverà il sollecito. Può essere ricordato solo una volta.",
  "remindSuccess": "Promemoria riuscito",
  "remindRepeat": "Questo ordine è stato ricordato.",
  "noComments": "Nessuna recensione al momento",
  "storeSeach": "Cerca il prodotto in questo negozio",
  "storeSeachTips1": "Trovato per te",
  "storeSeachTips2": "Negozi correlati trovati",
  "storeSeachTips3": "Casa",
  "creditTit": "Servizi di credito",
  "getCoupons": "Ottieni più coupon",
  "yourEmail": "Il tuo indirizzo di posta elettronica",
  "subscription": "Abbonamenti",
  "paymethods": "Metodo di pagamento",
  "footdec": "Gli utenti del sito globale di {name} provengono da {num} paesi in tutto il mondo e utilizzano {coin} per il pagamento. {coin} è una transazione senza confini che consente transazioni immediate ea basso costo in tutto il mondo senza attese e commissioni internazionali.",
  "custService": "Assistenza clienti",
  "helpLine": "Servizio clienti in linea",
  "contactUs": "Contattaci",
  "客户端下载":
    "Scarica il cliente",
  "partner": "Fornitori cooperativi",
  "提现方式": 
    "Modalità di rimborso",
  "buyRules": "Regole dell'acquirente",
  "sellerRules": "Politica del venditore",
  "returnsAndEx": "Resi e cambi",
  "servicePolicy": "Politica di servizio",
  "returnPolicy": "Politica di ritorno",
  "user_Center": "Centro utenti",
  "userReg": "Registrazione Utente",
  "orderTrack": "Domanda d'ordine",
  "purchageHistory": "Cronologia degli acquisti",
  "myPurse": "Il mio portafoglio",
  "aboutUs": "Chi siamo",
  "Recruitment": "Aspetta persone di talento",
  "news": "Informazioni sulle notizie",
  "stateMent": "Dichiarazione di schiavitù moderna",
  "binance": "Binanza",
  "huobi": "Hubi",
  "okx": "okx",
  "metaMask": "MetaMaschera",
  "homeBannertips1": "Diventa un commerciante",
  "homeBannertips2": "Commissione totale",
  "homeBannertips3": "Massimo.",
  "homeBannerbtn": "Iscriviti adesso",
  "homeDownloadtips1": "Centro commerciale all'ingrosso di e-commerce transfrontaliero",
  "homeDownloadtips2": "Offerta speciale di marca",
  "homeDownloadtips3": "Sconto continuo",
  "homeDownloadtips4": "Scarica Android",
  "homeDownloadtips5": "Scarica Apple",
  "homeDownloadtips6": "Scansiona il codice QR per scaricare l'APP",
  "homeIconTips1": "100% genuino",
  "homeIconTips2": "7 giorni di ritorno",
  "homeIconTips3": "Sconto sul trasporto",
  "homeIconTips4": "pagamento sicuro",
  "headerSearchTips": "Inserisci la parola chiave per la ricerca",
  "collAccount": "Modalità di prestito",
  "mine": "Mio.",
  "creditText1": "I prestiti di avvio risolvono il problema del prestito di denaro",
  "creditText2": "Fornire servizi di prestito iniziale e rotazione del capitale",
  "creditWorry": "Prestito senza preoccupazioni",
  "creditQuota": "Limite flessibile",
  "creditQuotaINFO": "Da 100.000 a 30.000.000 con limite flessibile e senza vincoli, con durata massima del prestito di un anno.",
  "quickLoan": "Prestito veloce",
  "creditReview": "Supera l'audit entro un'ora al più presto, se la revisione viene superata, il prestito verrà rilasciato immediatamente.",
  "safe": "Sicuro e senza preoccupazioni",
  "safeInfo": "Nessun mutuo, nessun deposito, nessuna richiamata, perché questa è in realtà una questione privata.",
  "about": "Chi siamo",
  "aboutText1": "\"Ci impegniamo a prestare servizi finanziari, basati sulla filosofia aziendale \"\"primo cliente\"\", con la missione di risolvere il problema della rotazione del capitale del cliente. Fin dalla sua fondazione, l'azienda ha aiutato numerosi clienti a risolvere il problema della rotazione del capitale.\"",
  "aboutText2": "Limite: 100.000-30.000.000, metodo di rimborso flessibile con interessi bassi, nessuna commissione anticipata, prestito online, nessuna telefonata per la verifica, informazioni riservate e prestito in giornata.",
  "contactUs1": "Se non vuoi prendere in prestito denaro dai tuoi compagni di livello, contattaci.",
  "committed": "Impegnato nei servizi di prestito all'imprenditore",
  "financial": "Affronta le tue preoccupazioni finanziarie",
  "partnersTit": "Piattaforma di prestito partner online",
  "application": "Domanda di prestito",
  "applicant": "Richiedente",
  "actualName": "Vero nome",
  "yourName": "Inserisci il nome",
  "term": "Durata del prestito",
  "applicationAmount": "Importo richiesto",
  "rates": "Tasso di interesse del prestito",
  "loanMethod": "Modalità di prestito",
  "accountB": "Saldo del conto",
  "countryOf": "Nazionalità",
  "myloan": "Il mio prestito",
  "applyLoan": "Chiedere un prestito",
  "loaned": "In prestito",
  "interest": "Interessi maturati",
  "esRepayment": "Rimborso stimato",
  "loanHistory": "Record di prestito",
  "applicantDate": "Data di applicazione",
  "repayment": "Rimborso",
  "cycle": "Ciclo di rimborso",
  "fixedRate": "Tasso di interesse fisso",
  "successLoan": "Prestito riuscito",
  "Reapply": "Riapplicare",
  "borrow": "Prestito fallito",
  "applicantIn": "Applicazione in corso",
  "repaid": "Rimborso",
  "overdue": "In ritardo",
  "estirepay": "Rimborso stimato",
  "loanDays": "Numero di giorni prestati",
  "reAmount": "Importo del rimborso",
  "repay": "Modalità di rimborso",
  "entRepay": "Conferma il rimborso",
  "foryourmoney": "Se sei in carenza di fondi, non trovi un posto dove prendere in prestito denaro o sei imbarazzato a prendere in prestito denaro dai tuoi amici, puoi contattarci. Abbiamo l'intero processo di servizio professionale per rispondere ai tuoi dubbi in qualsiasi momento. Il nostro obiettivo è rendere trasparente ogni prestito, in modo che i clienti possano utilizzarlo in modo rapido e sicuro.",
  "onlineApplin": "Applicare online",
  "businessloan": "Domanda di prestito iniziale",
  "selectCountry": "Seleziona una nazionalità",
  "selectPeriod": "Si prega di selezionare un periodo",
  "passPortImg": "ID n./Passaporto n.",
  "uploadId": "Caricamento foto certificato/passaporto",
  "readAndAgree": "Ho letto e sono d'accordo",
  "loanAgree": "Contratto di prestito",
  "submitApplica": "Presentazione della domanda",
  "photoExample": "Esempio di scattare foto",
  "discounted": "Prodotti scontati",
  "days": "giorno",
  "privacyPolicy": "Politica sulla riservatezza",
  "delivery": "Consegna e ritiro",
  "checkAgreement": "Si prega di spuntare l'accordo!",
  "businessPhone": "Telefono aziendale",
  "businessEmail": "Posta elettronica aziendale",
  "充值金额不能小于1": "L'importo della ricarica non può essere inferiore a 1 (compresi i due decimali)",
  "请切换其他语言后查看": "Passa a un'altra lingua per visualizzare",
  "我的购物车": "Il mio carrello",
  "推荐商品": "Prodotti consigliati",
  "猜你喜欢": "Immagino che ti piaccia.",
  "暂无店铺": "Nessun negozio trovato",
  "添加失败": "Impossibile inviare. Per favore riprova più tardi",
  "提交订单": "Invio dell'ordine",
  recommendclass:"Categoria consigliata",
  "滑动验证": "Verifica a scorrimento",
  "最多上传9张图片": "Carica fino a 9 immagini",
  "账号注销": "Disattivazione dell'account",
  "确定注销": "Conferma la disattivazione",
  "您的账号": "Il tuo account",
  "为什么要离开": "Perché lasciare?",
  "App下载(买家端)": "App download (buyer)",
  "App下载(卖家端)": "App download (seller)",
  "您还有余额,不能注销账号": "Hai ancora un saldo, non puoi disattivare l'account!",
  "请输入注销理由": "Inserisci il motivo per cui disattivi l'account",
  "您确认要注销吗?": "Sei sicuro di voler disattivare l'account?",
  "我再考虑下": "Rifletterò ancora",
  "最多包含10位小数": "Può contenere fino a 10 decimali",
  "同意注销": "Accetto la disattivazione",
  "注销成功": "Disattivazione riuscita",
  "请选择": "Si prega di selezionare",
  "绑定成功": "Vincolato con successo",
  "企业电话": "Telefono aziendale",
  "职业机会": "Opportunità di carriera",
  "仅能绑定一个收款地址!": "Puoi solo vincolare un indirizzo di pagamento!",
  "长时间未付款，系统自动取消订单": "Se non paghi per un lungo periodo di tempo, il sistema annullerà automaticamente l'ordine",
  "提款地址绑定": "Indirizzo di prelievo vincolato",
  "加密货币": "Valuta crittografica",
  "银行卡": "Carta bancaria",
  '参数缺失': "Parametro mancante",
  '充值数量必填': "L'importo della ricarica è obbligatorio",
  "充值币种": "Valuta di ricarica",
  "充值金额": "Importo della ricarica",
  "充值金额不得小于": "L'importo della ricarica non può essere inferiore a",
  "充值金额不得大于": "L'importo della ricarica non può essere superiore a",
  "请先选择币种": "Seleziona prima la valuta",
  "开户行": "Banca di deposito",
  "请输入开户行名称": "Inserisci il nome della banca di deposito",
  "银行卡号": "Numero di carta bancaria",
  "请输入银行卡号": "Inserisci il numero di carta bancaria",
  "点击去支付": "Fai clic per pagare",
  "企业证明": "Certificato aziendale",
  footTipTikTok:'Centro commerciale BizSpring ©️2024 Copyright',
  TikTokFoot:"BizSpring è una piattaforma sociale globale di video brevi BizSpring e la più grande società di commercio all'ingrosso dell'Asia Alibaba, fondata in collaborazione. È una piattaforma di e-commerce globale e dispone di tre magazzini intelligenti autogestiti nel mondo, situati a Toronto, in Canada, Los Angeles e Chiba, in Giappone. I prodotti in vendita nell'app includono prodotti popolari provenienti da Giappone, Corea del Sud, Cina e altri paesi asiatici. Al momento, il numero totale ha superato i 50.000 e continua a crescere rapidamente.",
  "cancelInfo":"avvisare! Fai attenzione a cancellare l'account. Se non utilizzi più l'account, puoi fare clic su [Accetta cancellazione]. Potresti non essere in grado di registrarti entro pochi giorni dalla cancellazione."
,
  "getCouponSuccess": "Coupon ricevuto",
  "liveRooms": "Sale Live",
  "liveStreaming": "In Diretta",
  "notStarted": "Non Iniziato",
  "finished": "Terminato",
  "myPoints": "I Miei Punti",
  "searchGoods": "Cerca Prodotti",
  "points": "Punti",
  "point": "Punti",
  "stock": "Scorte",
  "spec": "Specifiche",
  "exchangeNow": "Riscatta Ora",
  "currentPoint": "I Miei Punti",
  "pointNotEnough": "Punti insufficienti"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "意大利语(it)",
    "addImageHint": "(Aggiungi immagini)",
    "deleteNode": "Elimina",
    "topPos": "Alto {n}",
    "col": "Colonna {n}",
    "pos": "Posizione {n}",
    "decoType_container": "Contenitore",
    "decoType_title": "Testo titolo",
    "decoType_richText": "Testo formattato",
    "decoType_notice": "Avviso",
    "decoType_blank": "Spaziatore",
    "decoType_banner": "Carosello",
    "decoType_imageSingle": "Immagine singola",
    "decoType_imageMulti": "Immagini multiple",
    "decoType_video": "Video",
    "decoType_goodsRecommend": "Prodotti consigliati",
    "decoType_goodsSelection": "Selezione prodotti",
    "decoType_seckill": "Vendita flash",
    "decoType_groupBuy": "Acquisto di gruppo",
    "decoType_coupon": "Coupon",
    "decoType_searchNav": "Navigazione ricerca",
    "decoType_search": "Casella di ricerca",
    "decoType_searchBox": "Casella di ricerca",
    "decoType_categoryNav": "Navigazione categorie",
    "decoType_goodsCategory": "Categoria prodotti",
    "decoType_navIconRow": "Icone di navigazione",
    "decoType_imageScroll": "Scorrimento immagini",
    "decoType_pageBanner": "Banner pagina",
    "decoType_tabs": "Schede",
    "decoType_brand": "Marca",
    "decoType_storeRecommend": "Negozi consigliati",
    "decoType_hotSelection": "Selezione popolare",
    "decoType_footerLinkGroup": "Link a piè di pagina",
    "decoType_partnerLogoRow": "Partner",
    "decoType_icpInfo": "Info ICP",
    "decoType_topNavMenu": "Navigazione superiore",
    "decoType_logoBlock": "Logo",
    "decoType_langSwitcher": "Lingua",
    "decoType_currencySwitcher": "Valuta",
    "decoType_loginBlock": "Accesso",
    "decoType_cartIcon": "Carrello",
    "decoType_messageIcon": "Messaggi",
    "seckillPrice": "Prezzo flash",
    "seckillTag": "Vendita flash",
    "seckillCountdown": "Termina tra",
    "seckillNotStarted": "Prossimamente",
    "seckillRushing": "In corso",
    "seckillWillStart": "Prossimamente",
    "seckillBuy": "Acquista (flash)",
    "groupPrice": "Prezzo di gruppo",
    "groupRequiredNum": "persone per il gruppo",
    "noGroupBuy": "Acquista da solo",
    "groupRule1": "1. Scegli prodotto",
    "groupRule2": "2. Avvia gruppo",
    "groupRule3": "3. Gruppo completo → spedizione",
    "marketingMoneyOff": "Sconto",
    "marketingFreeShipping": "Spedizione gratuita",
    "marketingGift": "Regalo",
    "marketingCoupon": "Coupon",
    "marketingGroup": "Acquisto di gruppo",
    "marketingSeckill": "Vendita flash",
    "marketingExpired": "Promozione scaduta",
    "marketingNotActive": "Promozione non attiva",
    "alreadyGotCoupon": "Ottenuto",
    "couponReceived": "Ricevuto",
    "hotSearch": "Ricerche popolari:"
}